import { http } from "@/http";

export default {
  list(params) {
    return http.get("/api/v1/admin/branch", { params });
  },
  get(id) {
    return http.get(`/api/v1/admin/branch/${id}`);
  },
  save(payload) {
    return http.post("/api/v1/admin/branch", payload);
  },
  update(id, payload) {
    return http.put(`/api/v1/admin/branch/${id}`, payload);
  },
  toggleStatus(id, isActive ) {
    return http.put(`/api/v1/admin/branch/${id}/active`, null, {
      params: {
        isActive
      }
    });
  },
  delete(id) {
    return http.delete(`/api/v1/admin/branch/${id}`);
  },
};